const MILLIMETERS_PER_FOOT = 304.8;
const MAX_RECONNECT_GAP_MILLIMETERS = 20.0;
const MAX_RECONNECT_GAP_FEET = MAX_RECONNECT_GAP_MILLIMETERS / MILLIMETERS_PER_FOOT;
const COMPARISON_EPSILON_FEET = 1e-6;

const GAP_FEET_KEYS = [
  'Gap Distance (ft)',
  'candidateDistanceFeet',
  'Position Offset (ft)',
  'gapFeet',
  'distanceFeet',
] as const;

const GAP_MILLIMETER_KEYS = [
  'candidateDistanceMm',
  'gapMm',
  'distanceMm',
  'Gap Distance (mm)',
  'Position Offset (mm)',
] as const;

export function isReconnectGapAllowed(distanceFeet: number): boolean {
  return (
    Number.isFinite(distanceFeet) &&
    distanceFeet >= 0 &&
    distanceFeet <= MAX_RECONNECT_GAP_FEET + COMPARISON_EPSILON_FEET
  );
}

export function isReconnectGapMetadataAllowed(
  additionalData?: Record<string, string>
): boolean {
  const gapFeet = tryResolveGapFeet(additionalData);
  return gapFeet == null || isReconnectGapAllowed(gapFeet);
}

export function hasReconnectGapMetadata(additionalData?: Record<string, string>): boolean {
  return tryResolveGapFeet(additionalData) != null;
}

export function tryResolveGapFeet(additionalData?: Record<string, string>): number | null {
  if (!additionalData) {
    return null;
  }

  for (const key of GAP_FEET_KEYS) {
    const value = tryReadNumber(additionalData[key]);
    if (value != null) {
      return value;
    }
  }

  for (const key of GAP_MILLIMETER_KEYS) {
    const value = tryReadNumber(additionalData[key]);
    if (value != null) {
      return value / MILLIMETERS_PER_FOOT;
    }
  }

  return null;
}

function tryReadNumber(rawValue: string | undefined): number | null {
  const normalizedValue = rawValue?.trim();
  if (normalizedValue == null || normalizedValue === '') {
    return null;
  }

  const parsed = Number(normalizedValue);
  if (Number.isNaN(parsed) && normalizedValue.toLowerCase() !== 'nan') {
    return null;
  }

  return parsed;
}
